import React from 'react';
import "./items.scss"
import Icon from '@iconify/react';
import logoReact from '@iconify/icons-ion/logo-react';
import bxlRedux from '@iconify/icons-bx/bxl-redux';
import bxlJavascript from '@iconify/icons-bx/bxl-javascript';
import nodejsIcon from '@iconify/icons-raphael/nodejs';
import htmlFive2 from '@iconify/icons-icomoon-free/html-five2';
import cssIcon from '@iconify/icons-vaadin/css';
import mongodbIcon from '@iconify/icons-cib/mongodb';
import logoPython from '@iconify/icons-carbon/logo-python';
import bootstrapIcon from '@iconify/icons-bi/bootstrap';
import Aos from 'aos';
import 'aos/dist/aos.css';

function Items() {
    Aos.init()

    return (
        <div>
            <Icon data-aos ="fade" data-aos-duration="2150" icon={logoReact} className="logo"/>
            <Icon data-aos ="fade" data-aos-duration="2450"  icon={bxlRedux} className="logo"/>
            <Icon data-aos ="fade" data-aos-duration="2350" icon={bxlJavascript} className="logo"/>
            <Icon data-aos ="fade" data-aos-duration="2450" icon={nodejsIcon}  className="logo"/>
            <Icon data-aos ="fade" data-aos-duration="2550" icon={htmlFive2} className="logo"/>
            <Icon data-aos ="fade" data-aos-duration="2650" icon={cssIcon}  className="logo"/>
            <Icon data-aos ="fade" data-aos-duration="2750" icon={mongodbIcon} className="logo"/>
            <Icon data-aos ="fade" data-aos-duration="2850" icon={logoPython} className="logo"/>
            <Icon data-aos ="fade" data-aos-duration="2950" icon={bootstrapIcon} className="logo"/>
        </div>
    );
}

export default Items;